import { render, staticRenderFns } from "./BulmaRadio.vue?vue&type=template&id=13a5414f"
import script from "./BulmaRadio.vue?vue&type=script&lang=js"
export * from "./BulmaRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a5414f')) {
      api.createRecord('13a5414f', component.options)
    } else {
      api.reload('13a5414f', component.options)
    }
    module.hot.accept("./BulmaRadio.vue?vue&type=template&id=13a5414f", function () {
      api.rerender('13a5414f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaRadio/BulmaRadio.vue"
export default component.exports